import React, { useEffect } from 'react';
import '../css/Doks.css'; // Import the CSS file for styling

const Doks = ({ faqs }) => {
    const adjustCardHeights = () => {
        const cards = document.querySelectorAll(".nav-grid__item");
        let maxHeight = 0;

        cards.forEach((card) => {
            card.style.height = "auto"; // Reset before calculating
            maxHeight = Math.max(maxHeight, card.offsetHeight);
        });

        cards.forEach((card) => {
            card.style.height = `${maxHeight}px`;
        });
    };
    useEffect(() => {
        adjustCardHeights();
        window.addEventListener("resize", adjustCardHeights);
        return () => window.removeEventListener("resize", adjustCardHeights);
    }, []);
    return (
        <>
            <div className="hero-subheader hero-subheader--before-out">
                <div className="container" style={{ marginBottom: "90px", marginTop: "70px" }}>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="align-container" data-mh="" >
                                <div className="align-inner" style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center" }}>
                                    <p className="" style={{ fontSize: "16px", marginBottom: "10px", color: "#0b253f" }}>
                                        Capabilities
                                    </p>
                                    <h2 className="hero-subheader__title">{faqs.title}</h2>
                                    {/* <p className="hero-subheader__desc">
              Doks is Jekyll theme created for project documentations.
              <br /> You can use it with GitHub and GitLab Pages as well as a
              standalone project.
            </p> */}
                                    {/* <a
              href="/blue/getting-started"
              className="btn btn--dark btn--rounded btn--w-icon"
            >
              <i className="icon icon--arrow-right" /> Let's get started
            </a> */}
                                </div>
                                {/* /.align-inner */}
                            </div>
                            {/* /.align-container */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container */}
            </div>
            <div className="section section--darker-theme-color-bg">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="nav-grid nav-grid--out">
                                <div className="row gy-2">
                                    {faqs.sections.map(({ id, heading, content,image }, index) => (
                                        <div className="col-sm-6 col-lg-4" key={id}>
                                            <a type='button' role='button' className="nav-grid__item  ">
                                                <h2
                                                    className="nav-grid__btn nav-grid__title d-flex justify-content-between"
                                                   
                                                >
                                                    <span  dangerouslySetInnerHTML={{ __html: heading }}/>
                                                    <img src={image} style={{width:"50px",height:"50px",objectFit:"cover"}} alt='' />
                                                </h2>
                                                <div
                                                    className="nav-grid__content"
                                                    data-mh=""
                                                    style={{ height: "190px" }}
                                                >
                                                    <p>
                                                        {content}
                                                    </p>
                                                </div>
                                            </a>

                                        </div>
                                    ))}
                                </div>
                                {/* /.row */}
                            </div>
                            {/* /.nav-grid */}
                        </div>
                        {/* /.col */}
                    </div>
                    {/* /.row */}
                </div>
                {/* /.container */}
            </div>

        </>

    );
};

export default Doks;